<template>
  <div>
    <h3>{{item.name}}
      <span v-if="item.detail" class="subheader">{{item.detail}}</span>
    </h3>
    <h5 v-if="item.level === 0" class="level">
      {{item.school}} Cantrip
    </h5>
    <h5 v-else-if="item.rank " class="level">
      {{item.rank}}
      <span v-if="!['PF Playtest', 'PFRPG2', 'Embers RPG'].includes(item.ruleset) && item.school">{{lowerCase(item.school)}}</span>
    </h5>
    <h5 v-else-if="item.level || item.school" class="level">
      {{item.level}}<!--
      --><span v-if="item.level === 1">st</span><!--
      --><span v-else-if="item.level === 2">nd</span><!--
      --><span v-else-if="item.level === 3">rd</span><!--
      --><span v-else-if="item.level">th</span><!--
      --><span v-if="item.level">-level</span>
      <span v-if="!['PF Playtest', 'PFRPG2', 'Embers RPG'].includes(item.ruleset) && item.school">{{lowerCase(item.school)}}</span>
    </h5>
    <div><strong v-if="item.prepared">[prepared]</strong></div>
    <div v-if="item.description" v-html="$embers.markdown(item.description)"></div>
  </div>
</template>
<script>
export default {
  name: "sheet-spells-display",
  props: ["item", "ruleset"],
  methods: {
    lowerCase(value) {
      return value.toLowerCase();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/_global";

.level {
  font-style: italic;
  color: $primary;
  margin-top: -0.5rem;
}
</style>
